import React, { useEffect, useState } from "react";
import { apiClient } from "../../config/api";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { getSubjectsByStandard } from "../../utils/subjectService";
import "./PrathmikVibhag.css";
import SectionDivider from "../../common/SectionDivider";

const PrathmikVibhag = () => {
  const [standards, setStandards] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStandards = async () => {
      try {
        const res = await apiClient.get("/standard");
        setStandards(res.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchStandards();
  }, []);

  const handleClick = async (standard) => {
    try {
      const subjects = await getSubjectsByStandard(
        standard.standard_index
      );

      localStorage.setItem(
        "subjectsData",
        JSON.stringify(subjects)
      );
      localStorage.setItem(
        "selectedStandard",
        JSON.stringify(standard)
      );

      navigate("/subjects");
    } catch (e) {
      console.error(e);
    }
  };

  if (loading) return <Loader />;

  const colors = ["#4b34fa", "#0C9D26", "#F9B025", "#FD2D2B", "#D020CD"];

  return (
    <div className="pv-container">

        <SectionDivider title="પ્રાથમિક વિભાગ ના દરેક ધોરણો" />

      <div className="pv-row">
        {standards
          .filter(
            (s) =>
              Number(s.standard_index) >= 1 &&
              Number(s.standard_index) <= 5
          )
          .map((item, index) => (
            <div
              key={item.id}
              className="pv-card-new"
              style={{ "--accent": colors[index % colors.length] }}
              onClick={() => handleClick(item)}
            >
              <div className="pv-card-top">
                <div className="pv-circle-outer">
                  <div className="pv-circle-new">
                    {item.standard_index}
                  </div>
                </div>
              </div>

              <div className="pv-bottom-band">
                {item.standard_title}
              </div>
            </div>
          ))}
      </div>

    </div>
  );
};

export default PrathmikVibhag;
